// src/components/auth/AuthForm.jsx
import React from 'react';

export default function ContactForm({ title, imageSrc, children, footer, extraContentBelowImage }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4 py-8">
      <div className="max-w-4xl w-full bg-white rounded-lg shadow-md grid grid-cols-1 md:grid-cols-2 overflow-hidden">
        {/* Left Side: Form */}
        <div className="p-8 flex flex-col justify-center">
          <h2 className="text-xl font-semibold mb-4">{title}</h2>
          {children}
          {footer && <div className="mt-6 text-sm text-center">{footer}</div>}
        </div>

        {/* Right Side: Image and Extra Content */}
        <div className="bg-[#FFF3ED] p-6 flex flex-col items-center justify-center text-center">
          <img src={imageSrc} alt="Illustration" className="max-w-xs mb-6" />
          {extraContentBelowImage}
        </div>
      </div>
    </div>
  );
}
